/* eslint-disable import/default */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PostHogProvider } from 'posthog-js/react'
import "@copilotkit/react-ui/styles.css";
import './index.css'

const posthogKey = (import.meta.env as any).VITE_PUBLIC_POSTHOG_KEY ?? import.meta.env.VITE_POSTHOG_KEY
const posthogHost = (import.meta.env as any).VITE_PUBLIC_POSTHOG_HOST ?? import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <PostHogProvider
            apiKey={posthogKey}
            options={{
                api_host: posthogHost,
                capture_pageview: false,
            }}
        >
            <App />
        </PostHogProvider>
    </React.StrictMode>
)
